import { render, staticRenderFns } from "./DetailsStatistics.vue?vue&type=template&id=280b19fe&scoped=true&"
import script from "./DetailsStatistics.vue?vue&type=script&lang=js&"
export * from "./DetailsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b19fe",
  null
  
)

export default component.exports